import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="mn-footer" role="contentinfo" data-testid="site-footer">
      <div className="footer-grid">
        <div>
          <p className="footer-brand">Nerolya <em>Cosmetic</em></p>
          <p className="footer-tagline">{t("footer.tagline")}</p>
          <div className="footer-certifs">
            <span className="footer-certif">Bio certifié</span>
            <span className="footer-certif">ECOCERT</span>
            <span className="footer-certif">Vegan</span>
            <span className="footer-certif">Cruelty-free</span>
          </div>
        </div>

        <div className="footer-col">
          <h4>{t("footer.house")}</h4>
          <ul>
            <li><Link to="/pages/notre-histoire" data-testid="footer-histoire">Notre histoire</Link></li>
            <li><Link to="/pages/notre-ethique" data-testid="footer-ethique">Notre éthique</Link></li>
            <li><Link to="/pages/nos-ingredients" data-testid="footer-ingredients">Nos ingrédients</Link></li>
            <li><Link to="/blog" data-testid="footer-rituels">{t("nav.rituals")}</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>{t("footer.service")}</h4>
          <ul>
            <li><Link to="/pages/livraison" data-testid="footer-livraison">Livraison & retours</Link></li>
            <li><Link to="/pages/suivi-commande" data-testid="footer-suivi">Suivi de commande</Link></li>
            <li><Link to="/pages/faq" data-testid="footer-faq">FAQ</Link></li>
            <li><Link to="/pages/contact" data-testid="footer-contact">Nous contacter</Link></li>
            <li><Link to="/pages/programme-fidelite" data-testid="footer-fidelite">Programme fidélité</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>{t("footer.follow")}</h4>
          <ul>
            <li><a href="https://instagram.com" rel="noopener noreferrer" target="_blank">Instagram</a></li>
            <li><a href="https://pinterest.com" rel="noopener noreferrer" target="_blank">Pinterest</a></li>
            <li><a href="https://tiktok.com" rel="noopener noreferrer" target="_blank">TikTok</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2026 Nerolya Cosmetic — Cosmétique Ancestrale du Maroc. {t("footer.rights")}</p>
        <div className="footer-legal">
          <Link to="/pages/mentions-legales">Mentions légales</Link>
          <Link to="/pages/confidentialite">Confidentialité</Link>
          <Link to="/pages/cgu">CGV</Link>
          <Link to="/pages/cookies">Cookies</Link>
        </div>
      </div>
    </footer>
  );
}
